import { push } from 'connected-react-router';
import { SET_AVAILABILITY_STATUS, SUBMITTING } from './constants';

export const setOnlineStatus = isAvailable => ({
  type: SET_AVAILABILITY_STATUS,
  payload: isAvailable
});

export const setAvailabilityStatus = (isAvailable, idToken, id) => {
  return async (dispatch) => {
    dispatch({ type: SUBMITTING, payload: true });
    const headers = new Headers();

    headers.append('Authorization', `Bearer ${idToken}`);
    headers.append('Content-type', 'application/json');

    const data = { id, isAvailable };

    const options = {
      method: 'POST',
      headers,
      body: JSON.stringify(data),
    }

    const response = await fetch(`${process.env.REACT_APP_API}/api/deliveries`, options);

    if (response.status === 200) {
      dispatch(setOnlineStatus(isAvailable));
      dispatch({ type: SUBMITTING, payload: false });
    } else if (response.status === 401) {
      dispatch({ type: SUBMITTING, payload: false });
      dispatch(push('/login'));
    } else {
      dispatch({ type: SUBMITTING, payload: false });
    }
  };
};
